import React, { useState, useEffect } from 'react';

export const useLocalStorage = <S>({
  key: initialKey,
  initialState,
  reducer,
}: {
  key: string;
  initialState: S | (() => S);
  reducer?: React.Reducer<any, any>;
}): [S, React.Dispatch<React.SetStateAction<S>>] => {
  const key = `sb-uls:${initialKey}`;
  const [state, setState] = useState(() => {
    const item = localStorage.getItem(key);

    try {
      return item ? JSON.parse(item) : initialState;
    } catch (error) {
      return initialState;
    }
  });

  const dispatch = reducer
    ? (action: React.ReducerAction<any>) => {
        const nextState = reducer(state, action);
        setState(nextState);
        return action;
      }
    : (value: any) => setState(value);

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return [state, dispatch];
};
